import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute } from './root'
import { AppSkeleton } from '../fragments/appSkeleton'

const createRedirectRoute = (oldPath: string, newPath: string) =>
  createRoute({
    getParentRoute: () => rootRoute,
    path: oldPath,
    pendingComponent: AppSkeleton,
    pendingMs: 2000, // Higher pendingMs so we don't flash a pending component if this happens quickly
    beforeLoad: async ({ params, search }) => {
      throw redirect({
        to: newPath,
        params,
        search,
        replace: true,
      })
    },
  })

const routesMap: [string, string][] = [
  ['/shipment/$id/shipping-documents', '/shipments/$id/documents'],
  ['/shipment/$id/cost-breakdown', '/shipments/$id/price-breakdown'],
  ['/shipment/$id/shipping-instructions', '/shipments/$id/details'],
  ['/shipment/$id/$', '/shipments/$id'], // Fallback for overview, activity feed, and any other pages
  ['/bookings/$id/activityfeed', '/bookings/$id'], // This covers the activity feed link in email notifications for new messages
  ['/bookings', '/'], // bookings and shipments are both listed on the same page in Ship-v2
  ['/invoices', '/billing'],
  ['/quote-sheet/$id', '/quotes/$id/book'], // we don't have the quote sheet details on ship-v2, so go directly to the quote booking. Note that it only works for valid quotes, otherwise it's treated as unauthorized
  ['/quote-request/$', '/bookings/create'], // This covers new quotes and saved templates, since there's no direct equivalent in Ship-v2
  ['/notification-center/settings/$path', '/notification-center/settings'], // covers /preferences and /advanced
  ['/directory/organization/$id', '/'], // Ship-v2 doesn't have the "Company Account" page currently
  ['/company/activity', '/'], // Ship-v2 doesn't have the "Company Activity" page currently
  ['/company/users/$path', '/company/users'], // covers /create and /$id, for create and edit user pages which are modals without urls here
  ['/tracking', '/'], // Ship-v2 doesn't have a dedicated tracking page
  ['/booking-requests', '/'], // don't show booking requests on ship-v2
  ['/reports/edit', '/reports/create'], // /edit is the page for creating reports in ship-v1
]

export const redirectShipV1Routes = routesMap.map(([oldPath, newPath]) => createRedirectRoute(oldPath, newPath))
